<template>
    <div :class="`${prefixCls}`">
        <div :class="getTreeNodeClasses()">
            <div :class="`${prefixCls}-node-expand-icon`" v-if="showExpandIcon">
                <span :class="`${prefixCls}-node-expand-loading`" v-show="loading"></span>
                <Expand 
                    v-show="!loading" 
                    :expand="expand" 
                    @click="handleExpand"/>
            </div>
            <div :class="`${prefixCls}-node-content`"
                :style="{
                    height: height,
                    ['line-height']: height
                }">
                <slot name="content"></slot>
            </div>
            <slot name="operate"></slot>
            <div :class="`${prefixCls}-node-checkbox`" 
                v-if="showChecked">
                <CheckBox 
                    :checked="checked" 
                    @click="handleChecked"/> 
            </div>
            <div :class="`${prefixCls}-node-checkbox`" 
                v-if="showIndeterminate">
                <Indeterminate 
                    :checked="indeterminate" 
                    @click="handleChecked"/> 
            </div>
        </div>
        <div v-show="expand" :class="`${prefixCls}-node-children`">
            <slot name="children"></slot>
        </div>
    </div>
</template>
<script>
    import Expand from './expand'
    import CheckBox from './checkbox'
    import Indeterminate from './indeterminate'

    const prefixCls = 'yy-select-member-tree'
    export default {
        props: {
            showExpand: {
                type: Boolean,
                default: true
            },
            showExpandIcon: {
                type: Boolean,
                default: true
            },
            showChecked: {
                type: Boolean,
                default: true
            },
            showIndeterminate: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            indeterminate: {
                type: Boolean,
                default: false
            },
            checked: {
                type: Boolean,
                default: false
            },
            expand: {
                type: Boolean,
                default: false
            },
            height: {
                type: String,
                default: '28px'
            }
        },
        components: {
            Expand,
            CheckBox,
            Indeterminate
        },
        data() {
            return {
                prefixCls: prefixCls
            }
        },
        methods: {
            getTreeNodeClasses() {
                return [
                    `${this.prefixCls}-node`,
                    {
                        [`${this.prefixCls}-node-expand`]: this.showExpand
                    }
                ]
            },
            handleExpand(isExpand) {
                this.$emit('handleExpand', isExpand)
            },
            handleChecked(isChecked) {
                this.$emit('handleChecked', isChecked)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/business/select-member/tree/tree-node.vue